let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8ZNno")).then(() => parcelRequire('g7Yw9'));